'use strict';

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
    Constants = require('constants/AppConstants'),
    AdminScaffoldingGeneric = require('components/Commons/AdminScaffolding/AdminScaffoldingGeneric'),
    Loading = require('components/Commons/Loading/Loading'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    GridItem = require('components/Commons/GridItem/GridItem'),
    Authentication = require('services/Security').Authentication,
    InventoryStore = require('stores/InventoryStore'),
    NumberUtils = require('utils/NumberUtils'),
    NavigationUtils = require('utils/NavigationUtils'),
    {Navigation} = require('react-router'),
    GridItemWithFilter = require('components/Commons/GridItem/GridItemWithFilter'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    ga = require('react-ga'),
    _ = require('lodash');

const ProductIconsAdmin = React.createClass({displayName: "ProductIconsAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            sectionSelected: Constants.BREWING_SECTION_NAME,
            selectedIcon: Constants.BREWING_SECTION_NAME,
            isEditMode: false,
            iconsMapping: null,
            productName: NavigationUtils.getQueryParam('productName')
        };
    },

    componentDidMount() {
        this.fetchIcons();
        ga.pageview('/product-icons-admin');
    },

    fetchIcons() {
        const self = this;
        const productIdSelected = NavigationUtils.getPathParam('products');
        InventoryStore.fetchIconByProduct(productIdSelected, function (response) {
            const applicantIcons = formatApplicantIcons(response.icons, response.iconsFromApplicant);
            const icons = markProductIcons(applicantIcons, response.iconsByProductFromApplicant);
            const iconsFiltered = _.filter(icons, icon => _.get(icon, 'iconDetail.name') !== Constants.TASK_NON_VISIBLE); // remove only this icons
            const iconsSorted = _.orderBy(iconsFiltered, 'iconDetail.name');
            const iconsPristine = _.cloneDeep(iconsSorted);
            self.setState({
                icons: iconsSorted,
                iconsPristine,
                beerStyleName: _.get(response, 'product.beerStyle.name'),
                productName: _.get(response, 'product.name'),
                iconsChanged: []
            });
        });
    },

    getIconChangedUpdated(iconChangedNew) {
        const {sectionSelected, iconsChanged, iconsPristine} = this.state;

        // find if already change the icon
        const iconChangedOld = _.find(iconsChanged, iconChanged => _.get(iconChanged, 'id') === _.get(iconChangedNew, 'id'));
        const existIconChanged = !!iconChangedOld;

        // ask if we apply the same change that before
        const isSomeStateIconChanged = isSameStateIcon(iconChangedOld, iconChangedNew, sectionSelected);
        let iconChangedUpdated;

        if (existIconChanged && isSomeStateIconChanged) {
            // we don't need to change nothing because is the same state
            iconChangedUpdated = iconsChanged;
        } else if (existIconChanged && isSomeStateIconChanged === false) {
            // we need to update the changed icon
            const iconsChangedFiltered = _.filter(iconsChanged, iconChanged => _.get(iconChanged, 'id') !== _.get(iconChangedNew, 'id'));
            iconChangedUpdated = _.concat(iconsChangedFiltered, iconChangedNew);
        } else if (!existIconChanged) {
            // just need to add the new changed icon
            iconChangedUpdated = _.concat(iconsChanged, iconChangedNew);
        } else {
            // we don't need to do nothing
            iconChangedUpdated = iconsChanged;
        }

        // filter all icon changed which have the same state of icon pristine
        iconChangedUpdated = _.filter(iconChangedUpdated, iconChanged => {
            const iconPristine = _.find(iconsPristine, iconPristine => _.get(iconPristine, 'id') === _.get(iconChanged, 'id'));
            const isSameStateIconPristine = isSameStateIcon(iconPristine, iconChanged, sectionSelected);
            return !isSameStateIconPristine;
        });

        // add where section came from the icon changed
        iconChangedUpdated = _.map(iconChangedUpdated, icon => {
            icon.sectionChanged = sectionSelected;
            return icon;
        });

        return iconChangedUpdated;
    },


    _saveChanges(icon, onSuccess, onFailure) {
        const {icons, iconsPristine} = this.state;
        const productIdSelected = NavigationUtils.getPathParam('products');
        const iconMappingConverted = InventoryStore.filterOnlyProductIconsChanged(icons, iconsPristine);

        InventoryStore.changeIconsFromProduct(productIdSelected, {
            iconsChanged: iconMappingConverted
        }, onSuccess, onFailure);
    },

    _onChangeSection(evt, index, value) {
        this.setState({
            sectionSelected: _.get(value, 'text')
        });
    },

    _onCancel() {
        this.fetchIcons();
        this.setState({
            filterText: ''
        });
    },

    _onCheckIcon(gridItemProps, filterText) {
        const {iconId} = gridItemProps;
        const {icons} = this.state;

        // update state of icon
        let currentIconChecked = _.find(this.state.icons, icon => icon.id === iconId);
        const oldStateIcon = isCheckedIcon(currentIconChecked);
        const newStateIcon = !oldStateIcon;
        currentIconChecked = updateSectionIcon(currentIconChecked, newStateIcon);

        const iconsFiltered = _.filter(icons, icon => icon.id !== currentIconChecked.id);
        const allIconsWithIconUpdated = _.concat(iconsFiltered, currentIconChecked);

        this.setState({
            icons: _.orderBy(allIconsWithIconUpdated, 'iconDetail.name'),
            iconsChanged: this.getIconChangedUpdated(currentIconChecked),
            filterText
        });
    },

    _backToProduct() {
        const productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
        this.transitionTo(
            `/products`,
            {},
            {
                productSelectedId
            }
        );
    },

    _goToProductItems() {
        const productIdSelected = NavigationUtils.getPathParam('products');
        const productName = NavigationUtils.getQueryParam('productName');
        const beerStyle = NavigationUtils.getQueryParam('beerStyle');
        const volume = NavigationUtils.getQueryParam('volume');
        const unit = NavigationUtils.getQueryParam('unit');
        const productSelectedId = NavigationUtils.getQueryParam('productSelectedId');

        this.transitionTo(`/products/${productIdSelected}/items`);

        this.transitionTo(
            `/products/:productId/:page`,
            {
                productId: productIdSelected,
                page: 'items'
            },
            {
                productSelectedId,
                productName,
                beerStyle,
                volume,
                unit
            }
        );
    },

    _goToProductItemsAddition() {
        const productIdSelected = NavigationUtils.getPathParam('products');
        const productName = NavigationUtils.getQueryParam('productName');
        const beerStyle = NavigationUtils.getQueryParam('beerStyle');
        const volume = NavigationUtils.getQueryParam('volume');
        const unit = NavigationUtils.getQueryParam('unit');
        const productSelectedId = NavigationUtils.getQueryParam('productSelectedId');

        this.transitionTo(`/products/${productIdSelected}/items`);

        this.transitionTo(
            `/products/:productId/items-addition`,
            {
                productId: productIdSelected
            },
            {
                productSelectedId,
                productName,
                beerStyle,
                volume,
                unit
            }
        );
    },

    _getBreadcrumbLinks() {
        const {productName, beerStyleName} = this.state;
        const volumeWithUnit = this._getVolumeWithUnit();
        return [
            {
                displayName: t('dashboard_sidebar_products'),
                link: 'products'
            },
            {
                displayName: `${productName} (${beerStyleName} ${volumeWithUnit})`
            }
        ];
    },

    _getVolumeWithUnit() {
        const unit = NavigationUtils.getQueryParam('unit');
        const volume = NavigationUtils.getQueryParam('volume');
        const volumeFormatted = NumberUtils.formatDecimal(volume);
        return `${volumeFormatted}${unit}`;
    },

    isChangedIcon(icon) {
        const {iconsChanged, sectionSelected} = this.state;
        const isChangedIcon = !!_.find(iconsChanged, iconChanged => _.get(iconChanged, 'id') === _.get(icon, 'id') && _.get(iconChanged, 'sectionChanged') === sectionSelected);

        return isChangedIcon;
    },

    render() {
        if (!this.state.icons) {
            return (
                React.createElement(Loading, null)
            );
        } else {
            const messages = {
                changeSuccessMessage: t('product_admin_change_success'),
                changeFailureMessage: t('product_admin_change_failure'),
                deleteSuccessMessage: t('product_admin_delete_success'),
                addSuccessMessage: t('product_admin_add_success'),
                addFailureMessage: t('product_admin_add_failure')
            };
            const additionalButtons = [
                {
                    permission: 'SHOW',
                    type: 'CHANGE',
                    el: React.createElement(FormGroupButton, {
                        label: t('back'), 
                        icon: "subdirectory_arrow_left", 
                        type: "icon", 
                        onClick:  this._backToProduct}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'SHOW',
                    el: React.createElement(FormGroupButton, {
                        label: t('back'), 
                        icon: "subdirectory_arrow_left", 
                        type: "icon", 
                        onClick:  this._backToProduct}
                    )
                },
                {
                    type: 'CHANGE',
                    permission: 'SHOW',
                    el: React.createElement(FormGroupButton, {
                        label: t('product_admin_set_subsctraction_icons'), 
                        icon: "subdirectory_arrow_right", 
                        type: "icon", 
                        onClick:  this._goToProductItems}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'SHOW',
                    el: React.createElement(FormGroupButton, {
                        label: t('product_admin_set_subsctraction_icons'), 
                        icon: "subdirectory_arrow_right", 
                        type: "icon", 
                        onClick:  this._goToProductItems}
                    )
                },
                {
                    type: 'CHANGE',
                    permission: 'SHOW',
                    el: React.createElement(FormGroupButton, {
                        label: t('product_admin_set_addition_icons'), 
                        icon: "subdirectory_arrow_right", 
                        type: "icon", 
                        onClick:  this._goToProductItemsAddition}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'SHOW',
                    el: React.createElement(FormGroupButton, {
                        label: t('product_admin_set_addition_icons'), 
                        icon: "subdirectory_arrow_right", 
                        type: "icon", 
                        onClick:  this._goToProductItemsAddition}
                    )
                }
            ];
            const contextHolder = this.getContextHolderInstance();
            const {selectedIcon, icons, iconsPristine} = this.state;
            const originalStateIcons = isOriginalState(icons, iconsPristine);

            const iconsFiltered = _.filter(icons, icon => isCurrentIconVisible(icon));

            return (
                React.createElement(AdminScaffoldingGeneric, {
                    title: t('product_admin_title'), 
                    moduleName: "ADMIN_PRODUCT_ICON", 
                    messages: messages, 
                    contextHolder: contextHolder, 
                    value:  originalStateIcons ? undefined : selectedIcon, 
                    fetchItems:  this.fetchIcons, 
                    headerFields: [], 
                    onChange:  originalStateIcons ? undefined : this._saveChanges, 
                    onCancel:  originalStateIcons ? undefined : this._onCancel, 
                    additionalButtons: additionalButtons, 
                    customClassName: "grid-item-content", 
                    breadcrumb: this._getBreadcrumbLinks()
                }, 
                    React.createElement(GridItemWithFilter, {
                        items: translateIcons(iconsFiltered, t), 
                        isCheckedItem: isCheckedIcon, 
                        isChangedItem: this.isChangedIcon, 
                        displayNameField: "iconDetail.displayNameText", 
                        iconClassNameField: "iconDetail.iconClassName", 
                        onCheckItem: this._onCheckIcon, 
                        initialFilterText: this.state.filterText, 
                        nonMatchingText: t('product_admin_non_matching_found'), 
                        keepSelectedSorting: false}
                    )
                )
            );
        }
    }
});

function isCheckedIcon(icon) {
    return !!_.get(icon, 'isProductIconChecked');
}

function isCurrentIconVisible(icon) {
    return _.get(icon, 'iconDetail.isBrewingAllowed')
        || _.get(icon, 'iconDetail.isFermentingAllowed')
        || _.get(icon, 'iconDetail.isPackagingAllowed');
}

function updateSectionIcon(icon, newCheckedState) {
    icon = _.set(icon, 'isProductIconChecked', newCheckedState);
    icon = _.set(icon, 'productIconChecked', newCheckedState);
    return icon;
}

function isOriginalState(iconsChanged, iconPristine) {
    return _.every(iconsChanged, iconChanged => {
        const iconCompare = _.find(iconPristine, iconPristine => iconPristine.id === iconChanged.id);
        return isSameStateIcon(iconCompare, iconChanged);
    });
}

function isSameStateIcon(icon, iconCompare) {
    if (icon && iconCompare) {
        const isCheckedIconCompare = isCheckedIcon(iconCompare);
        const isCheckedIconChanged = isCheckedIcon(icon);
        const isSameState = isCheckedIconCompare === isCheckedIconChanged;
        return isSameState;
    }
}

function translateIcons(icons, t) {
    return icons.map(icon => {
        icon.iconDetail.displayNameText = Constants.getIconsMapping(t)[icon.iconDetail.displayName] || icon.iconDetail.displayName;
        return icon;
    });
}

function formatApplicantIcons(allIcons, applicantIcons) {
    const applicantIconsIds = _.map(applicantIcons, icon => icon.id);
    const allIconsWithoutApplicantIcon = _.filter(allIcons, icon => !_.includes(applicantIconsIds, icon.id));
    const allIconsHydratedWithApplicantIcon = _.concat(allIconsWithoutApplicantIcon, applicantIcons);
    return allIconsHydratedWithApplicantIcon;
}

function markProductIcons(allIconsWithApplicantIcons, productIcons) {

    const productIconsId = _.map(productIcons, productIcon => _.get(productIcon, 'id'));

    return _.map(allIconsWithApplicantIcons, icon => {
        if (_.includes(productIconsId, icon.id)) {
            icon.isProductIconChecked = true;
        } else {
            icon.isProductIconChecked = false;
        }
        return icon;
    });
}

module.exports = ProductIconsAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/ProductsAdmin/ProductIconsAdmin.jsx
 **/